module.exports = __webpack_public_path__ + "media/images/themes/dark/select-arrows-light-63310f5121222cffd4ccb5c21a480f07.svg";